export default {
  whatsapp: {
    立即参加: "立即參加",
    还差X: "還差 ${X}",
    已满足参加中: "已滿足參與中",
    消费满X赠送价值Y现金券: "消費滿 ${X} 贈送價值 ${Y} 現金券",
    消费满X赠送Y张ZOFF折扣券: "消費滿 ${X} 贈送 {Y}張 {Z}%OFF 折扣券",
    消费满X获得Y张优惠券: "消費滿 ${X} 獲得 {Y} 張優惠券",
    立即领取: "立即領取",
    已经领取: "已經領取",
    参与中: "參與中",
  },
};
